<div mat-dialog-content class="text-center d-flex flex-column justify-content-center align-items-center">
  <img class="img-fluid" [src]="data?.imgUrl" alt="img">
  <p class="title mt-4">{{data?.title}}</p>
  <p class="description" [innerHTML]="data?.description"></p>
</div>
<div mat-dialog-actions class="d-flex flex-row justify-content-center align-items-center mb-3">
  <button (click)="onClose()" mat-stroked-button color="primary"
    class="close-btn rounded-5 me-2">{{data?.closeButtonName}}</button>
  <button (click)="onProceed()" mat-flat-button color="primary"
    class="proceed-btn rounded-5">{{data?.submitButtonName}}</button>
</div>